import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { Link, useParams } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import SectionHeroBanner from "../components/Common/SectionHeroBanner";
import MainTitle from "../components/Common/MainTitle";
import { BLOG_POSTS, NEWS_POSTS } from "../data/mediaContent";

const MediaArticlePage = () => {
  const { type, slug } = useParams();
  const posts = type === "blog" ? BLOG_POSTS : NEWS_POSTS;
  const post = posts.find((item) => item.slug === slug);
  const typeLabel = type === "blog" ? "Blog" : "News";

  if (!post) {
    return (
      <Fragment>
        <LayoutOne>
          <SectionHeroBanner title="Article Not Found" className="sectionAboutBg" />
          <div className="container py-5 sac-page-shell">
            <div className="sac-content-card">
              <p className="mb-3">This article could not be found.</p>
              <Link to={`/media/${type === "blog" ? "blog" : "news"}`} className="color-primary fw600">
                Back to {typeLabel}
              </Link>
            </div>
          </div>
        </LayoutOne>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <MetaTags>
        <title>{`${post.title} | South Asia Consultancy`}</title>
        <meta name="description" content={post.excerpt} />
      </MetaTags>
      <LayoutOne>
        <SectionHeroBanner title={typeLabel} className="sectionAboutBg" />
        <div className="container py-5 sac-page-shell">
          <article className="sac-content-card">
            <p className="sac-badge mb-2">{post.category}</p>
            <h1 className="MainTitle mb-2" style={{ fontSize: "34px", lineHeight: 1.25 }}>
              {post.title}
            </h1>
            <p className="text-muted mb-4" style={{ fontSize: "12px", letterSpacing: "0.3px", textTransform: "uppercase" }}>
              {post.date}
            </p>
            {post.content.map((paragraph) => (
              <p key={paragraph.slice(0, 20)} className="fs16px lnh-30">
                {paragraph}
              </p>
            ))}
            <hr />
            <MainTitle text="Need support for your project?" position="left" width="260px" />
            <p className="mb-2">Our team can support workforce planning, mobilization, and operations execution.</p>
            <Link to="/contact" className="color-primary fw600">
              Contact South Asia Consultancy
            </Link>
          </article>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default MediaArticlePage;
